import React from 'react';
import { Grid, Typography } from '@mui/material';
import { sxStyle } from './styles';

const RoomCardBlock = ({ title, children }) => {
  return (
    <Grid item sm={12} md={3} sx={sxStyle.bordersDownRight}>
      {title && <Typography sx={sxStyle.subTitles}>{title}</Typography>}
      {children}
    </Grid>
  );
};

export default RoomCardBlock;
